// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3ch08c","content":"_7tHF54","image":"_3NgaZ_"};